import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BellFilledSvg from "@ant-design/icons-svg/es/asn/BellFilled";
import AntdIcon from "../components/AntdIcon";
var BellFilled = function BellFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BellFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BellFilled.displayName = 'BellFilled';
}
export default /*#__PURE__*/React.forwardRef(BellFilled);